import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import Modal from "react-bootstrap/Modal";
import * as constantMessages from "../../constants/constatntMessages";
import { useSelector } from "react-redux";
import { textBoxStrLength } from "../../config/config";
import { checkCharacterLeft } from "../../helpers/commonHelpers";
import SmallLoaderButton from "../Common/SmallLoaderButton";
const regularExpressionForAgendaTitle =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=()/_'"\\\-?|{}\[\]]+$/;
const IsCompleteModal = React.memo((props) => {
  const regularExpression = /^[0-9a-zA-Z .(),/-]+$/;
  const [reason, setReason] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const actionData = useSelector((state) => state.action);
  useEffect(() => {
    return () => {
      if (actionData.isSuccess) {
      }
    };
  }, [actionData?.singleActionDetails?.isComplete, actionData.isSuccess]);

  const handleSubmit = () => {
    const newErrors = validateForm();
    setErrors(newErrors);
    setLoading(false);
    if (Object.keys(newErrors).length === 0) {
      props.handleSubmit(reason);
      setLoading(true);
    }
  };
  const validateForm = () => {
    const errors = {};
    if (!reason.trim()) {
      errors.reason = constantMessages.commentsRequired;
    } else if (reason.trim().length < 3 || reason.trim().length > 500) {
      errors.reason = constantMessages.largeStringLengthError;
    } else if (!regularExpressionForAgendaTitle.test(reason.trim())) {
      errors.reason = constantMessages.invalidReason;
    }

    setErrors(errors);
    return errors;
  };

  const closeModal = () => {
    setReason("");
    setErrors({});
    props.setIsModalOpen(false);
  };

  const updateValues = (e) => {
    setErrors({});
    const { name, value } = e.target;
    if (value.length <= textBoxStrLength) {
      setReason(value);
    }
  };

  return (
    <>
      <Modal show={props.isModalOpen} onHide={closeModal} backdrop="static">
        <div className="modal-header">
          <h4 className="modal-title">Mark As Completed</h4>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={closeModal}
          ></button>
        </div>
        <div className="modal-body delete-txt">
          <label className="mb-1">
            Remark
            <span className="star-mark">*</span>
          </label>
          <textarea
            cols="40"
            rows="4"
            id="remark"
            name="remark"
            onBlur={validateForm}
            onChange={updateValues}
            value={reason}
            required
          ></textarea>
          <p className="success-message">
            {checkCharacterLeft(reason)} Characters left
          </p>

          {errors.reason && (
            <span className="error-message">{errors.reason}</span>
          )}
        </div>

        <div className="modal-footer">
          {loading ? (
            <SmallLoaderButton />
          ) : (
            <button
              type="button"
              onClick={handleSubmit}
              className="Mom-btn btn btn-secondary bg-primary border-primary"
            >
              <p>Update</p>
            </button>
          )}
        </div>
      </Modal>
    </>
  );
});

export default IsCompleteModal;
